/**
 * This function extracts the bucket name and file path from a full path.
 * @example somebucket/some/folder/file.txt -> { bucket: "somebucket", filePath: "some/folder/file.txt" }
 * @param fullPath
 * @returns
 */
export function getBucketPath(fullPath: string): {
	bucket: string;
	filePath: string;
	directory: string;
	cleanPath: string;
} {
	const [bucket, ...pathParts] = fullPath.split("/");
	const directory = pathParts.at(0) || "";
	const cleanPath = pathParts.slice(1).slice(0, -1).join("/");
	return {
		bucket: bucket ?? "",
		filePath: pathParts.join("/"),
		directory,
		cleanPath,
	};
}
